<div class="dropdown dropdown__zero" style="display: flex">
  <div class="w-full">
    <div
      class="col-span-5 dropdown__items dropdown__items-zero"
      (click)="openDropdown($event)"
      [ngClass]="{ dropdown__itemSelected: isOpen }"
      [ngStyle]="{ 'background-color': isOpen ? 'white' : '#f5f5f5' }">
      <ng-container [ngTemplateOutlet]="dropdownItem" [ngTemplateOutletContext]="{ item: selectedItem }"></ng-container>
      <svg-icon
        key="arrow-down"
        size="lg"
        class="dropdown__arrow col-start-11 row-start-1"
        [ngClass]="{ 'dropdown__arrow--reverse': isOpen === true }"></svg-icon>
    </div>
    <div
      class="dropdown__items--open overflow-auto rounded dropdown__items--open-zero"
      [ngClass]="{ hidden: !isOpen }"
      [ngStyle]="{ 'box-shadow': isOpen ? '0px 4px 4px rgba(0, 0, 0, 0.08)' : null }">
      <div
        *ngFor="let item of items; let i = index"
        class="col-span-5 dropdown__items dropdown__items-zero"
        (click)="selectItem(item)"
        [ngStyle]="{ 'background-color': isOpen ? 'white' : '#f5f5f5' }"
        [ngClass]="{ 'dropdown__items--current': selectedItemPosition === i }">
        <ng-container [ngTemplateOutlet]="dropdownItem" [ngTemplateOutletContext]="{ item: item }"></ng-container>
      </div>
    </div>
  </div>
  <div class="col-start-11 flex justify-end items-center col-span-3 gap-1.5" style="height: 47px">
    <div
      class="flex items-center justify-center col-start-10"
      (mouseover)="mouseOnRepeat = !mouseOnRepeat"
      (mouseout)="mouseOnRepeat = !mouseOnRepeat">
      <svg-icon
        size="lg"
        key="{{ selectedItem?.field2 === status?.PENDING ? 'icon-rotate-cw-disabled' : 'icon-rotate-cw' }}"
        class="dropdown__icon-zero mx-1.5 col-start-10 cursor-pointer relative"
        [ngClass]="{ 'dropdown__icon-zero--hover': selectedItem?.field2 !== status?.PENDING }"
        (click)="repeatActivity()">
      </svg-icon>
      <div
        *ngIf="mouseOnRepeat && selectedItem?.field2 !== status?.PENDING"
        class="absolute top-full bg-textoGrisOscuro text-white p-2 rounded mt-2">
        <span>{{ 'f.generic.repeat.activity' | translate }}</span>
      </div>
    </div>
    <div class="flex items-center justify-center col-start-10" (mouseover)="mouseOnPrevious = true" (mouseout)="mouseOnPrevious = false">
      <svg-icon
        size="exl"
        key="{{ selectedItemPosition < 1 ? 'arrow-left-disabled' : 'arrow-left-mo' }}"
        class="cursor-pointer"
        (click)="previousItem()"></svg-icon>
      <div *ngIf="mouseOnPrevious && selectedItemPosition >= 1" class="absolute top-full bg-textoGrisOscuro text-white p-2 rounded mt-2">
        <span>{{ 'f.generic.previous' | translate }}</span>
      </div>
    </div>
    <div class="flex items-center justify-center col-start-12" (mouseover)="mouseOnNext = true" (mouseout)="mouseOnNext = false">
      <svg-icon
        size="exl"
        key="{{ selectedItemPosition >= items.length - 1 ? 'arrow-right-disabled' : 'arrow-right-mo' }}"
        class="cursor-pointer"
        (click)="nextItem()"></svg-icon>
      <div
        *ngIf="mouseOnNext && selectedItemPosition < items.length - 1"
        class="absolute top-full bg-textoGrisOscuro text-white p-2 rounded mt-2">
        <span>{{ 'f.generic.next' | translate }}</span>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="currentTemplate"></ng-container>
  </div>
</div>

<ng-template #dropdownItem let-item="item">
  <div class="widget__tooltip col-span-4">
    <p class="justify-self-start ml-6 bodySMedium dropdown__field1" (mousemove)="tooltipFollowMouse($event)">{{ item?.field1 }}</p>
    <ng-container [ngTemplateOutlet]="tooltip" [ngTemplateOutletContext]="{ item: item?.field1 }"></ng-container>
  </div>
  <div class="col-start-6 col-span-2">
    <tags [status]="item?.field2" [isVisibleStatus]="!isResourceActivity" (mousemove)="tooltipFollowMouse($event)"></tags>
  </div>
  <div class="widget__tooltip text-grisMedio3 col-start-8 col-span-2 justify-self-start">
    {{ item?.field5 === '' ? '-' : (item?.field5 | customDateFormat) }}
  </div>
  <div class="widget__tooltip col-start-10 col-span-1">
    <p (mousemove)="tooltipFollowMouse($event)">{{  item?.field3 }}</p>
    <ng-container *ngIf="!isLomloeEnv" [ngTemplateOutlet]="tooltip" [ngTemplateOutletContext]="{ item: tooltipField3 }"></ng-container>
  </div>
  <div class="widget__tooltip col-start-11 justify-self-start">
    <p *ngIf="item?.field4" (mousemove)="tooltipFollowMouse($event)">{{ item?.field4 }}</p>
    <ng-container *ngIf="!isLomloeEnv" [ngTemplateOutlet]="tooltip" [ngTemplateOutletContext]="{ item: tooltipField4 }"></ng-container>
  </div>
</ng-template>

<ng-template #tooltip let-item="item">
  <span>{{ item }}</span>
</ng-template>
